/* Ranking da equipe de captação.

   O RLS de perfis impede um captador de ler os colegas, e está certo assim.
   Por isso o ranking vem de uma função security definer no Postgres, que
   devolve só o agregado: posição, nome e quantidade de casos. Nome de
   cliente, CPF, telefone e documento nunca saem por aqui, senão um captador
   conseguiria chegar no cliente do outro.

   A função é criada na migração 005. */

import { sb } from "../supabase.js";

/* Primeiro dia do mês corrente, no formato que o Postgres entende. */
export function inicioDoMes(){
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-01`;
}

/* Ranking do período. Sem argumento, conta o mês corrente. */
export async function rankingCaptadores(desde = inicioDoMes()){
  const { data, error } = await sb.rpc("ranking_captadores", { p_desde: desde });
  if (error) throw error;
  return (data || []).map(l => ({ ...l, casos: Number(l.casos), posicao: Number(l.posicao) }));
}
